/* eslint-disable unused-imports/no-unused-vars-ts */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { FieldMetaState } from "react-final-form";
import { FieldsType } from "@flatsy/core/Form/Library/Types";

/**
 * @name renderHelpersText
 * @description render a string or undefined if have error, custom error or helper text
 * @param field: FieldsType,
 * @param touched?: boolean | undefined,
 * @param error?: any,
 * @param submitError?: any,
 * @param submitSucceeded?: boolean,
 * @param justSubmitted?: boolean,
 * @param modified?: boolean
 */
export const renderHelpersText = (
  field: FieldsType,
  touched?: boolean | undefined,
  error?: any,
  submitError?: any
  // submitSucceeded?: boolean,
  // justSubmitted?: boolean,
  // modified?: boolean
): any => {
  if (field && field.helper) {
    if (field.customErrorText) {
      // eslint-disable-next-line no-nested-ternary
      return touched
        ? error || submitError
          ? field.customErrorText
          : field.helper
        : field.helper;
    }
    return touched ? error || submitError || field.helper : field.helper;
  }

  if (field && field.customErrorText) {
    return (
      touched && (error || submitError ? field.customErrorText : undefined)
    );
  }

  return touched && (error || submitError);
};

/**
 * render a col number to make the form grid
 * @param field FieldsType
 * @param isXs boolean
 */
export const renderCol = (
  field: FieldsType,
  isXs: boolean
):
  | boolean
  | 2
  | 1
  | 12
  | "auto"
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | undefined => {
  if (field && field.colXs && isXs) {
    return field.colXs;
  }
  if (field && field.col) {
    return field.col;
  }

  return 12;
};

/**
 * @description return a boolean or undefined for error management
 * @param meta
 */
export const renderErrorInField = (
  meta: FieldMetaState<string>
): boolean | undefined => {
  return meta.touched && (!!meta.error || !!meta.submitError);
};

/**
 * @description return a boolean or undefined for state management
 * @param meta
 */
export const renderUpdatedInField = (
  meta: FieldMetaState<string>,
  justSubmitted: boolean
): boolean | undefined => {
  return meta.submitSucceeded && meta.modified && justSubmitted;
};

export const getFieldControls = (
  field: FieldsType
): { success: boolean; error: string | boolean; hasControls: boolean } => {
  if (field && field.controls) {
    return {
      success: !field.controls.showError ? field.controls.showSucess : false,
      error: field.controls.showError,
      hasControls: true,
    };
  }
  return {
    success: false,
    error: false,
    hasControls: false,
  };
};
